export default __webpack_public_path__ + "static/assets/805bd19e55fcfb40b332b4faf41c1b59.png";